import { Appointment } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";
import { appointmentApi } from "../service";
import { auditLogKeys } from "../../../audit-log";

/**
 * `Rückgängig` behind a mistaken tap. Clears the last stamped instant — a reset, so the next tap
 * records an honest "now" and no remembered time can be planted.
 */
export function useRevertAppointmentPhase() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, workOrderId }: { id: number; workOrderId?: string }) => {
      const { data } = await appointmentApi.revertPhase(id);
      return { appointment: data as Appointment, workOrderId };
    },
    onSettled: (_data, _err, vars) => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      // Clearing an instant re-derives the occupied block, so the calendar has to refetch too.
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      if (vars?.workOrderId) {
        queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(vars.workOrderId) });
      }
    },
  });
}
